import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { BarChart3, X } from "lucide-react";
import { api } from "../lib/api";
import InteractivePoll from "./InteractivePoll";

// "Vote now" pill — surfaces whichever poll is the most recently created
// AND still open, letting fans vote right from the header without leaving
// the page (tapping it opens a small popover with the live InteractivePoll).
// Renders nothing if there's no open poll to show.
export function PollVotePill({ large = false }) {
  const [poll, setPoll] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/polls")
      .then((r) => {
        const live = (r.data || []).find((p) => !p.closed);
        setPoll(live || null);
      })
      .catch(() => {});
  }, []);

  if (!poll) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="poll-vote-pill"
        aria-label="Vote in the current fan poll"
        title="Vote in the current fan poll"
        className={`inline-flex items-center justify-center gap-1.5 rounded-full border border-black/15 bg-white font-display text-xs font-bold text-[var(--brand-ink)] hover:border-[#0A0F17] sm:h-auto sm:w-auto sm:justify-start sm:px-3 sm:py-1.5 ${
          large ? "h-11 w-11" : "h-6 w-6"
        }`}
      >
        <BarChart3 size={large ? 20 : 16} strokeWidth={2.5} className="sm:hidden" />
        <BarChart3 size={12} strokeWidth={2.5} className="hidden sm:inline" />
        <span className="hidden sm:inline">Vote now</span>
      </button>

      {open ? createPortal(
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
          data-testid="poll-vote-modal"
          onClick={() => setOpen(false)}
        >
          <div className="relative w-full max-w-md max-h-[90vh] animate-scale-up" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Close"
              data-testid="poll-vote-close"
              className="absolute -top-3 -right-3 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-[#0A0F17] text-white shadow-md hover:opacity-90"
            >
              <X size={14} />
            </button>
            <div className="max-h-[90vh] overflow-y-auto scrollbar-thin rounded-md">
              <InteractivePoll pollId={poll.id} scrollableOptions />
            </div>
          </div>
        </div>,
        document.body
      ) : null}
    </>
  );
}

export default PollVotePill;
